import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Page } from "@models/page";
import { Transfer } from "@models/transfer";
import { hasInputChanged } from "@shared/helpers/hasChanges/hasChanges.helper";
import { PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { TransferInvitationCardComponent } from "./transfer-invitation-card/transfer-invitation-card.component";

@Component({
    selector: "app-transfers-invitations-list",
    imports: [SkeletonModule, ButtonComponent, TransferInvitationCardComponent],
    templateUrl: "./transfer-invitations-list.component.html",
    styleUrl: "./transfer-invitations-list.component.scss"
})
export class TransferInvitationsListComponent implements OnChanges {
  @Input() invitationsPage: Page<Transfer> | null = null;
  @Input() isLoading = false;

  @Output() acceptInvitationClick = new EventEmitter<number>();
  @Output() declineInvitationClick = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<PaginatorState>();

  invitations: Transfer[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    const hasChanges = hasInputChanged<
      TransferInvitationsListComponent,
      "invitationsPage"
    >(changes, "invitationsPage");
    if (hasChanges) {
      const invitationChanges: SimpleChanges["invitationsPage"] =
        changes["invitationsPage"];

      const newPage = invitationChanges.currentValue?.meta.page;
      const oldPage = invitationChanges.previousValue?.meta.page;

      if (invitationChanges && invitationChanges.currentValue?.data) {
        if (oldPage != null && newPage! > oldPage) {
          this.invitations.push(...invitationChanges.currentValue.data);
        } else {
          this.invitations = [...invitationChanges.currentValue.data];
        }
      }
    }
  }

  loadMoreInvitations() {
    const paginationMeta = this.invitationsPage?.meta;

    if (paginationMeta) {
      const paginatorState: PaginatorState = {
        page: paginationMeta.current_page,
        pageCount: 10,
      };
      this.pageChange.emit(paginatorState);
    }
  }

  handleAcceptClick(invitationId: number) {
    this.acceptInvitationClick.emit(invitationId);
  }

  handleDeclineClick(invitationId: number) {
    this.declineInvitationClick.emit(invitationId);
  }
}
